// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Auth
import { AccountService } from '../../../../mbs/services/account/account.service';

@Component({
    selector: 'kt-forgot-password',
    templateUrl: './forgot-password.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
    // Public params
    forgotPasswordForm: FormGroup;
    loading = false;
    errors: any = [];

    constructor(
        public accountService: AccountService,
        private translate: TranslateService,
        private router: Router,
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.initRegistrationForm();
    }

    ngOnDestroy(): void {
        this.loading = false;
    }

    initRegistrationForm() {
        this.forgotPasswordForm = this.fb.group({
            email: [
                '',
                Validators.compose([Validators.required, Validators.email, Validators.minLength(3), Validators.maxLength(320)]),
            ],
        });
    }

    requestPassword() {
        const controls = this.forgotPasswordForm.controls;

        if (this.forgotPasswordForm.invalid) {
            Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
            return;
        }

        this.accountService.requestPassword(this.forgotPasswordForm.value).subscribe((response) => {
            setTimeout(() => {
                this.router.navigate(['/auth/login']);
            }, 2000);
        });
    }

    /**
     * Checking control validation
     *
     * @param controlName: string => Equals to formControlName
     * @param validationType: string => Equals to valitors name
     */
    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.forgotPasswordForm.controls[controlName];
        if (!control) {
            return false;
        }

        const result = control.hasError(validationType) && (control.dirty || control.touched);
        return result;
    }
}
